import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
} from '@angular/forms';
import { PlaceSearchResult } from '@app/components/pr-form/pr-input-map/pr-input-map.component';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, combineLatest } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'notary-info',
  templateUrl: './notary-info.component.html',
  styleUrls: ['./notary-info.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
      deps: [[new SkipSelf(), ControlContainer]],
    },
  ],
  standalone: false,
})
export class NotaryInfoComponent implements OnInit {
  @Input() derrors = false;
  subscriptions: any[] = [];
  countries: any[];
  departments: any[];
  doneSubject: Subject<void> = new Subject<void>();
  options: FormControlOption[] = [
    {
      value: 'option1',
      label:
        'Le conjoint de l’adhérent, ni divorcé, ni séparé de corps, à défaut son partenaire avec lequel il est lié par un Pacte civil de solidarité, à défaut les enfants nés ou à naître de l’adhérent, vivants et non renonçants ou représentés, par parts égales, à défaut les héritiers de l’adhérent.',
      suffix: { title: 'A' },
    },
    {
      value: 'option2',
      label:
        'Les enfants nés ou à naître de l’adhérent, vivants et non renonçants ou représentés, par parts égales, à défaut les héritiers de l’adhérent.',
      suffix: { title: 'B' },
    },
  ];
  toValue: PlaceSearchResult = { address: '' };

  constructor(
    private controlContainer: FormGroupDirective,
    private referenceDao: ReferenceDao,
  ) {}
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }
  ngOnInit() {
    combineLatest([this.referenceDao.getCountries()])
      .pipe(untilDestroyed(this))
      .subscribe(([countries]) => {
        this.countries = countries;
      });
  }
}
